module.exports = __webpack_public_path__ + "media/images/fut-tablet-e370813d3a941f653d25ce0cc3a7a12e.jpg";